<div [outerHTML]="labelText | sanitize: 'html'"></div>
<ng-content></ng-content>
